import { handleActions } from 'redux-actions';
import { dismiss, notify } from './actions';

const initialState = {
  messages: [],
};

const defaultReducer = handleActions(
  {
    [notify]: (state, { payload: { type, content, data, desktop } }) => ({
      ...state,
      messages: [...state.messages, { key: Date.now(), type, content, data, desktop }],
    }),
    [dismiss]: (state, { payload: { key } }) => ({
      ...state,
      messages: state.messages.filter(message => message.key !== key),
    }),
  },
  initialState
);

export default defaultReducer;
